const blockClick = event => {
    event.preventDefault();
    event.stopPropagation();
}

export default blockClick;